import AssignmentItem from "./AssignmentItem";

const AssignmentsList = ({ assignments }) => {
  if (!Array.isArray(assignments)) return null;
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "var(--gap-base)",
        marginBottom: "var(--padding-section-bottom)",
      }}
    >
      {assignments?.map((assignment) => (
        <AssignmentItem key={assignment?.id} assignment={assignment} />
      ))}
    </div>
  );
};

export default AssignmentsList;
